import { Moment } from 'moment';
import { QuestResponseType } from '../Quotation/Quotation.types';

export enum HourlyCostFilterDateBy {
  entry = 'Entry',
  authorization = 'Authorization',
  closing = 'Closing',
  leave = 'Leave',
}
export enum HourlyCostSituation {
  open = 'domain.enums.work_order_status.open',
  authorized = 'domain.enums.work_order_status.authorized',
  closed = 'domain.enums.work_order_status.closed',
  cancelled = 'domain.enums.work_order_status.cancelled',
}

export enum HourlyCostWorkOrderTypes {
  courtesy = 'domain.enums.work_order_type.courtesy',
  warranty = 'domain.enums.work_order_type.warranty',
  workOrder = 'domain.enums.work_order_type.work_order',
  totalLoss = 'domain.enums.work_order_type.total_loss',
  return = 'domain.enums.work_order_type.return',
  revision = 'domain.enums.work_order_type.revision',
}

export interface QuestReportHourlyCostRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  costByEmployee: number;
  filterDateBy: HourlyCostFilterDateBy;
  situation?: HourlyCostSituation[];
  workOrderTypes?: HourlyCostWorkOrderTypes[];
  employeesIds?: string;
  subAreasIds?: string;
  startDate: string;
  endDate: string;
}

export interface QuestReportHourlyFormValues {
  companiesIds?: number[];
  costByEmployee: number;
  filterDateBy: HourlyCostFilterDateBy;
  situation?: HourlyCostSituation[];
  workOrderTypes?: HourlyCostWorkOrderTypes[];
  employeesIds?: number[];
  subAreasIds?: number[];
  initialDate: Moment;
  finalDate: Moment;
}
